import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight';
import { Link } from 'gatsby';
import type { FC } from 'react';
import Image from '../../../shared/image';

const ProductCard: FC<{
  name: string;
  href: string;
  description: string;
  image: string;
}> = ({ href, name, image }) => {
  return (
    <Link className="contents" to={href}>
      <div
        className="productListingHome hover:bg-action-btn text-center flex flex-col items-center bg-gray-200 px-4 py-4 rounded-md hover:text-white"
        id="product-card-hovered sm:w-64 w-full"
      >
        <p className="font-semibold text-2xl items-center">{name}</p>
        <Link
          className="flex my-3.5 text-red-600 font-bold text-base space-x-1 items-center transition-smooth hover:-translate-y-1"
          to={href}
        >
          <span className="bg-clip-text items-center">KNOW MORE</span>
          <BsArrowRight className="mt-px" />
        </Link>
        <div className="h-52">
          <Image
            alt="..."
            className="object-contain w-full h-52"
            height={208}
            src={image}
          />
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
